import { cn } from '../../lib/utils';

export const MatchCard = ({ match, homeTeam, awayTeam, showDate = true, showTime = false }) => {
  const isPlayed = match.is_played;

  const formatTime = (isoStr) => {
    const date = new Date(isoStr);
    return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
  };

  return (
    <div 
      className={cn(
        "match-card transition-all duration-300 hover:border-l-gold",
        isPlayed && "border-l-gold"
      )}
      data-testid={`match-card-${match.id}`}
    >
      {showDate && (
        <p className="text-[10px] sm:text-xs text-slate-500 mb-2 sm:mb-3 font-medium uppercase tracking-wider">
          {new Date(match.match_date).toLocaleDateString('it-IT', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'UTC'
          })}
        </p>
      )}
      
      <div className="flex items-center justify-between w-full gap-2 sm:gap-4">
        {showTime && (
          <span className="text-xs font-numbers text-slate-400 w-10 shrink-0">
            {formatTime(match.match_date)}
          </span>
        )}
        <div className="flex-1 text-right min-w-0">
          <p className="font-heading text-sm sm:text-base md:text-lg font-bold uppercase leading-tight">
            {homeTeam?.name || 'TBD'}
          </p>
        </div>
        
        <div className="flex items-center gap-1.5 sm:gap-3 px-2 sm:px-4 flex-shrink-0">
          {isPlayed ? (
            <>
              <span className="font-numbers text-2xl sm:text-3xl md:text-4xl font-bold text-white">{match.home_score}</span>
              <span className="text-slate-600 font-numbers text-lg sm:text-2xl">-</span>
              <span className="font-numbers text-2xl sm:text-3xl md:text-4xl font-bold text-white">{match.away_score}</span>
            </>
          ) : (
            <span className="text-slate-500 font-heading text-base sm:text-xl">VS</span>
          )}
        </div>
        
        <div className="flex-1 text-left min-w-0">
          <p className="font-heading text-sm sm:text-base md:text-lg font-bold uppercase leading-tight">
            {awayTeam?.name || 'TBD'}
          </p>
        </div>
      </div>
      
      {match.phase !== 'group' && (
        <div className="mt-2">
          <span className="text-[10px] sm:text-xs px-2 py-1 bg-gold/20 text-gold rounded font-semibold uppercase">
            {match.phase === 'quarterfinal' && `Quarti - ${match.leg === 1 ? 'Andata' : 'Ritorno'}`}
            {match.phase === 'semifinal' && `Semifinale - ${match.leg === 1 ? 'Andata' : 'Ritorno'}`}
            {match.phase === 'final_3_4' && 'Finale 3°/4° Posto'}
            {match.phase === 'final_1_2' && 'FINALE'}
          </span>
        </div>
      )}
    </div>
  );
};

export default MatchCard;
